import React, { useState, useEffect, useCallback } from 'react';
import axios from './adminAxios';

const ManageAutoReplies = () => {
    const [replies, setReplies] = useState([]);
    const [trigger, setTrigger] = useState('');
    const [response, setResponse] = useState('');

    const fetchReplies = useCallback(async () => {
        try {
            const res = await axios.get('/auto-replies');
            const data = Array.isArray(res.data) ? res.data : (res.data.replies || []);
            setReplies(data);
        } catch (err) {
            console.error("Error fetching replies:", err);
            setReplies([]);
        }
    }, []);

    useEffect(() => {
        fetchReplies();
    }, [fetchReplies]);

    const handleAdd = async (e) => {
        e.preventDefault();
        try {
            await axios.post('/auto-replies', { trigger, response });
            setTrigger('');
            setResponse('');
            fetchReplies();
        } catch (err) {
            alert("Trigger already exists or server error.");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Terminate this global auto-reply sequence?")) {
            try {
                const targetId = String(id).trim();
                await axios.delete(`/auto-replies/${targetId}`);
                fetchReplies();
            } catch (err) {
                console.error("Delete failed:", err);
            }
        }
    };

    const styles = {
        container: { padding: '30px', color: '#fff', fontFamily: "'Inter', sans-serif" },
        header: { color: '#03f8d7', letterSpacing: '2px', marginBottom: '20px', textTransform: 'uppercase' },
        form: { 
            background: 'rgba(13, 13, 18, 0.95)', 
            padding: '20px', 
            borderRadius: '12px', 
            border: '1px solid rgba(3, 248, 215, 0.15)',
            marginBottom: '30px',
            display: 'flex',
            gap: '15px'
        },
        input: {
            background: '#060608',
            border: '1px solid rgba(3, 248, 215, 0.3)',
            color: '#fff',
            padding: '12px',
            borderRadius: '8px',
            outline: 'none',
            fontSize: '13px',
            boxSizing: 'border-box'
        },
        button: {
            background: 'rgba(3, 248, 215, 0.1)',
            border: '1px solid #03f8d7',
            color: '#03f8d7',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            fontSize: '11px',
            letterSpacing: '1px'
        },
        table: { width: '100%', borderCollapse: 'collapse', background: 'rgba(13, 13, 18, 0.5)', borderRadius: '12px', overflow: 'hidden' },
        th: { textAlign: 'left', padding: '15px', borderBottom: '2px solid rgba(3, 248, 215, 0.2)', color: '#64748b', fontSize: '12px', letterSpacing: '1px' },
        td: { padding: '15px', borderBottom: '1px solid rgba(255,255,255,0.05)', fontSize: '13px' }
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.header}>🤖 Robot Command Center (Global)</h2>
            
            <form onSubmit={handleAdd} style={styles.form}>
                <input 
                    type="text" 
                    placeholder="TRIGGER KEYWORD" 
                    value={trigger} 
                    onChange={(e) => setTrigger(e.target.value)} 
                    required 
                    style={{ ...styles.input, flex: 1 }}
                />
                <input 
                    type="text" 
                    placeholder="ROBOT RESPONSE MESSAGE" 
                    value={response} 
                    onChange={(e) => setResponse(e.target.value)} 
                    required 
                    style={{ ...styles.input, flex: 2 }}
                />
                <button type="submit" style={styles.button}>Deploy Reply</button>
            </form>

            <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={styles.th}>TRIGGER</th>
                        <th style={styles.th}>RESPONSE</th>
                        <th style={styles.th}>CONTROL</th>
                    </tr>
                </thead>
                <tbody>
                    {replies.map(r => (
                        <tr key={String(r._id)}>
                            <td style={{ ...styles.td, color: '#03f8d7', fontWeight: 'bold' }}>{r.trigger}</td>
                            <td style={styles.td}>{r.response}</td>
                            <td style={styles.td}>
                                <button 
                                    onClick={() => handleDelete(r._id)} 
                                    style={{ background: 'none', border: 'none', color: '#ff2d75', cursor: 'pointer', fontWeight: 'bold', fontSize: '11px' }}
                                >
                                    TERMINATE
                                </button>
                            </td>
                        </tr>
                    ))}
                    {replies.length === 0 && (
                        <tr>
                            <td colSpan="3" style={{ ...styles.td, textAlign: 'center', color: '#64748b' }}>No automated sequences active.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default ManageAutoReplies;